import { RegionShared } from "@1games-ru/region-shared";
import { Equipment, Inventory } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import { IS_DEV } from "@/domains/main/constants/other";
import { reset, setEquipment, setInventory } from "@/domains/inventory/slice";
import createFakeInventory from "@/domains/inventory/helpers/createFakeInventory";

export default function useShowInventory() {
  const [isShowSearch, setIsShowSearch] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Inventory.ShowSearchThePlayer,
      async (data: typeof RegionShared.Cef.Requests.ShowSearchThePlayerRequest) => {
        dispatch(reset());

        const { targetCharacterId } = data;

        const reqData: typeof RegionShared.Cef.Requests.ShowSearchThePlayerRequest = {
          targetCharacterId,
        };

        const response:
          | RpcMpProviderFailedResponse
          | RpcMpProviderSuccessResponse<
              typeof RegionShared.Backend.Responses.SearchThePlayerResponse
            > = await RpcMpProvider.getInstance().callServer(
          RegionShared.Backend.Events.Inventory.SearchThePlayer,
          reqData,
        );

        if (response instanceof RpcMpProviderSuccessResponse) {
          dispatch(setInventory(response.data.inventory as unknown as Inventory));
          dispatch(setEquipment(response.data.equipment as unknown as Equipment));
          const confiscationInventory = createFakeInventory({
            id: -1,
            ownerId: response.data.inventory.ownerId,
            ownerType: OwnerType.Confiscation,
            size: { height: 15, width: 7 },
          });
          dispatch(setInventory(confiscationInventory));
        }

        setIsShowSearch(true);

        return true;
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Inventory.ShowSearchThePlayer);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Inventory.HideSearchThePlayer, async () => {
      dispatch(reset());

      setIsShowSearch(false);

      return true;
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Inventory.HideSearchThePlayer);
    };
  }, []);

  return {
    isShowSearch: !!(isShowSearch || IS_DEV),
  };
}
